import { useEffect, useState } from 'react';

import { useOnline } from '@mint-lib/hooks';
import { useTranslation } from '@mint-lib/i18n';

import { Snackbar } from '@myn/mui';

export const OfflineNetworkStatusAlert = () => {
  const { t } = useTranslation('@mint-admin/secured-layout');

  const isOnline = useOnline();
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    if (isOnline) {
      setIsClosed(false);
    }
  }, [isOnline]);

  if (isOnline || isClosed) {
    return null;
  }

  return (
    <Snackbar
      open={!isOnline || !isClosed}
      title={t(`You are offline`)}
      subTitle={t('You are offline some ARM features are not available')}
      textLayout="multiline"
      severity="warning"
      onClose={() => setIsClosed(true)}
      removable
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{ top: '771px' }}
    />
  );
};
